<template>
    <div class="card shadow mb-3">
        <div class="card-header py-3">
            <h6 class="m-0 font-weight-bold text-primary">
                <i class="fas fa-info-circle text-muted"
                   style=""
                   data-toggle="tooltip"
                   data-placement="top"
                   :title="$info['timing.period']"></i>
                Zeitraum
            </h6>
        </div>
        <div class="card-body">

            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label>Von</label>
                        <div class="row">
                            <div class="col">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">Monat</span>
                                    </div>
                                    <input type="number" class="form-control" placeholder="01" v-model="config.startMonth">
                                </div>
                            </div>
                            <div class="col">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">Jahr</span>
                                    </div>
                                    <input type="number" class="form-control" placeholder="2022" v-model="config.startYear">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="form-group">
                        <label>Bis</label>
                        <div class="row">
                            <div class="col">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">Monat</span>
                                    </div>
                                    <input type="number" class="form-control" placeholder="12" v-model="config.endMonth">
                                </div>
                            </div>
                            <div class="col">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">Jahr</span>
                                    </div>
                                    <input type="number" class="form-control" placeholder="2022" v-model="config.endYear">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group mb-2" v-if="modeSelect">
                <label>Zeitraum Modus</label>
                <select class="form-control" v-model="config.periodMode">
                    <option value="full">Summe</option>
                    <option value="monthly">Monatlich</option>
                    <option value="quarterly">Quartalsweise</option>
                </select>
            </div>

            <div class="form-check" v-if="compare">
                <input class="form-check-input" type="checkbox" value="" id="timing-compare" v-model="config.comparePeriods">
                <label class="form-check-label" for="timing-compare">
                    Vergleich mit Vorjahr
                </label>
            </div>

        </div>
    </div>
</template>

<script>

export default {
    props: {
        dto: {
            type: Object,
            required: true
        },
        compare: {
            type: Boolean,
            default: true
        },
        modeSelect: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            config: this.dto
        };
    },
}
</script>
